import { DELETE_MEDICAL_RECORD } from './constants';
import { NO_ACCESS } from './fetchMedicalRecords';
import fetchWithRefresh from './fetchWithRefresh';

const NOT_FOUND = 'NOT_FOUND';
export default (docId: string, plId: string): Promise<void> => {
    return fetchWithRefresh(DELETE_MEDICAL_RECORD(docId, plId), {
        method: 'DELETE',
    }).then((res) => {
        if (res.status === 200) {
            return;
        } else if (res.status === 403) {
            // no access
            throw new Error(NO_ACCESS);
        } else if (res.status === 404) {
            throw new Error(NOT_FOUND);
        } else {
            throw new Error('failed to delete medical record');
        }
    });
};
